import "../userDashboard.css";
import { SmileOutlined } from "@ant-design/icons";
import { Result } from "antd";
import { useAppDispatch } from "../../../Redux/reduxCustomHook";
import { removeItem } from "../../../utils/localStorage";
import { USER_AUTH_DATA_KEY, USER_TOKEN_KEY } from "../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const UserLogout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    doLogout();
  }, []);

  const doLogout = () => {
    removeItem(USER_TOKEN_KEY);
    removeItem(USER_AUTH_DATA_KEY);
    dispatch({ type: "AUTH_REMOVE_DATA" });
    setTimeout(() => {
      navigate("/");
    }, 1500);
  };

  return (
    <Result
      status="404" // Status 404 might be semantically incorrect for a logout confirmation.
      icon={<SmileOutlined rev={undefined} />} // Icon should be fine with AntD theme
      title={<span className="text-gray-900 dark:text-stone-100">Logout</span>}
      subTitle={<span className="text-gray-600 dark:text-stone-400">You are Logged Out Successfully</span>} // Changed text for clarity
    />
  );
};

export default UserLogout;
